
import {Component} from '@angular/core'

@Component({
    templateUrl:'../view/faq.html'
})

export class FAQComponent {

}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Home/component/faq.ts